import styled, { css } from 'styled-components'
import colors from '../../constants/colors'
import Box from '../Box'
import Flex from '../Flex'
import { FlexProps } from '../Flex/Flex.types'

export const Wrapper = styled.span`
  .react-datepicker {
    border: solid 1px ${colors.black10};
    box-shadow: 0px 4px 10px rgba(20, 20, 32, 0.08);
    padding: 24px;
    border-radius: 8px;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__header.react-datepicker__header--custom {
    background-color: unset;
    border: none;
  }

  .react-datepicker__day-names {
    display: flex;
    justify-content: space-between;
  }

  .react-datepicker__week {
    display: flex;
    justify-content: space-between;
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__month-container {
    float: none;
    width: 272px;
  }

  .react-datepicker__day-name {
    color: ${colors.black50};
  }

  .react-datepicker__day {
    color: ${colors.black75};
  }
  .react-datepicker__day--disabled {
    color: ${colors.black25};
  }
  .react-datepicker__day--outside-month {
    color: ${colors.white};
    cursor: default;
    &:hover {
      background-color: white;
      color: none;
    }
  }

  .react-datepicker__day--today {
    color: ${colors.blue50};
    background-color: ${colors.blue5};
    border-radius: 4px;
  }

  .react-datepicker__day--selected {
    &:hover {
      background-color: ${colors.blue25};
    }
    color: ${colors.white};
    background-color: ${colors.blue50};
    font-weight: 400;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: white;
    &:hover {
      background-color: #f0f0f0;
    }
  }

  .react-datepicker__day--excluded {
    color: ${colors.black25} !important;
  }
`

export const RangePickerWrapper = styled.span`
  .react-datepicker {
    border: solid 1px ${colors.black10};
    box-shadow: 0px 4px 10px rgba(20, 20, 32, 0.08);
    padding: 24px;
    border-radius: 8px;
    display: flex;
    column-gap: 48px;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__header.react-datepicker__header--custom {
    background-color: unset;
    border: none;
  }

  .react-datepicker__day-names {
    display: flex;
    justify-content: space-between;
  }

  .react-datepicker__week {
    display: flex;
    justify-content: space-between;
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__month-container {
    float: none;
    width: 272px;
  }

  .react-datepicker__day-name {
    color: ${colors.black50};
  }

  .react-datepicker__day {
    color: ${colors.black75};
  }

  .react-datepicker__day--outside-month {
    color: ${colors.white};
    cursor: default;
    &:hover {
      background-color: white;
      color: none;
    }
  }

  .react-datepicker__day--today {
    color: ${colors.blue50};
    background-color: ${colors.blue5};
    border-radius: 4px;
  }

  .react-datepicker__day--selected {
    &:hover {
      background-color: ${colors.blue25};
    }
    color: ${colors.white};
    background-color: ${colors.blue50};
    font-weight: 400;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: white;
    &:hover {
      background-color: #f0f0f0;
    }
  }
  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range {
    background-color: ${colors.blue5} !important;
    position: relative;
    z-index: 10;
    border-radius: 0;
    ::before {
      content: ' ';
      position: absolute;
      top: 0;
      left: -7px;
      width: 7px;
      height: 100%;
      background-color: ${colors.blue5};
    }
    ::after {
      content: ' ';
      position: absolute;
      top: 0;
      right: -7px;
      width: 7px;
      height: 100%;
      background-color: ${colors.blue5};
    }
  }

  .react-datepicker__day--in-selecting-range.react-datepicker__day--weekend,
  .react-datepicker__day--weekend.react-datepicker__day--in-range.react-datepicker__day--weekend {
    ::before {
      border-radius: 8px;
      left: -10px;
      width: 11px;
    }
    ::after {
      border-radius: 8px;
      right: -10px;
      width: 11px;
    }
  }

  .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start.react-datepicker__day--weekend,
  .react-datepicker__day--range-start.react-datepicker__day--in-range.react-datepicker__day--weekend {
    ::before {
      content: none;
    }
    ::after {
      content: ' ';
      position: absolute;
      top: 0;
      right: -7px;
      width: 7px;
      height: 100%;
      border-radius: 0 8px 8px 0;
      background-color: ${colors.blue5};
    }
  }

  .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-end.react-datepicker__day--weekend,
  .react-datepicker__day--range-end.react-datepicker__day--in-range.react-datepicker__day--weekend {
    ::after {
      content: none;
    }
    ::before {
      content: ' ';
      position: absolute;
      top: 0;
      left: -7px;
      width: 7px;
      height: 100%;
      border-radius: 8px 0 0 8px;
      background-color: ${colors.blue5};
    }
  }

  .react-datepicker__day--range-start.react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start {
    color: ${colors.white};
    background-color: ${colors.blue50} !important;
    border-radius: 4px;
    ::before {
      content: none;
    }
  }

  .react-datepicker__day--range-end.react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-end {
    color: ${colors.white};
    background-color: ${colors.blue50} !important;
    border-radius: 4px;
    ::after {
      content: none;
    }
  }

  .react-datepicker__day--range-end.react-datepicker__day--in-range.react-datepicker__day--outside-month {
    color: ${colors.blue5};
    background-color: ${colors.blue5} !important;
  }
`

export const TimeWrapper = styled(Flex)`
  ::-webkit-scrollbar {
    display: none;
  }
`

export const Time = styled(Flex)<FlexProps & { isActive: boolean }>`
  ${(props) =>
    !props.isActive &&
    css`
      :hover {
        background-color: ${colors.black5};
      }
    `}
`

export const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: ${colors.black10};
`
